var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "None",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 12.333152,5.42377 h -10e-4 c -1.5631,0 -3.0665001,-0.60941 -4.1816001,-1.69836 -1.45596,-1.43284 -3.72553,-1.52254 -5.27514,-0.26993 v 6.65362 c 2.18322,-1.0001 4.84314,-0.6077 6.66074,1.1772 1.4507001,1.4274 3.7284001,1.513 5.2865001,0.256 V 4.85636 c -0.7824,0.35655 -1.6386,0.54543 -2.5104,0.54543 z m 3.9523,7.46523 c 0.3138,-0.1687 0.5284,-0.5011 0.5284,-0.8815 V 3.0162 c 0,-0.33812 -0.1636,-0.63245 -0.414,-0.81242 -0.3903,-0.29704 -0.9475,-0.27252 -1.2999,0.08102 -1.5531,1.51853 -4.0322,1.51853 -5.5755001,0 -2.3297,-2.2868 -6.04341,-2.2868 -8.36321,9.9e-4 -0.02987,0.02998 -0.0697,0.06994 -0.09956,0.1099 C 0.80479194,2.68828 0.75125194,3.0829 0.88416194,3.42031 V 19.0008 c 0,0.5495 0.43807996,0.999 0.99562996,0.999 0.54759,0 0.99562,-0.4495 0.99562,-0.999 v -6.5524 c 1.54965,-1.2541 3.82036,-1.1649 5.27684,0.2685 1.1151,1.0889 2.6185001,1.6984 4.1816001,1.6984 l -0.0298,-0.023 c 1.4628,0 2.8814,-0.5317 3.9814,-1.5033 z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontWeight: "bold",
      fontSize: 14,
      fontFamily: "Arial",
      fill: "#171717"
    },
    x: 15,
    y: 23
  }, "1"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag1);
export default __webpack_public_path__ + "static/media/flag1.477d36da813dca87715b07ea1409161d.svg";
export { ForwardRef as ReactComponent };